import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { DataRevisionIndicator } from '../../shared';
import { LabTestResultGridRowItem } from '../grid-row-item';
import { ModalDialogService } from './model-dialog/ModalDialogService';
import { StandardTestResultsData } from './standard-test-result-data';
import { ModalData } from './model-dialog/data-revision/data-revision.component';

@Component({
    selector: 'test-visit-cell',
    template: require('./test-visit-ag-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestVisitAgRendererComponent implements AgRendererComponent {

    public visitTitle: string;
    public revisionMessage: string;
    public hasDataRevision: boolean;
    public labtestId: number;
    public resultdata: StandardTestResultsData;
    public protocol: string;
    public participantNumber: string;
    public investigatorNumber: string;
    public accessionNumber: string;
    public visitDescription: string;
    constructor(private dataRevisionIndicator: DataRevisionIndicator, private readonly changeDetectorRef: ChangeDetectorRef, public modalDialogService: ModalDialogService) {
        this.revisionMessage = dataRevisionIndicator.visitDataRevisionMessage;
    }

    public refresh() {
        return false;
    }

    public agInit(row: LabTestResultGridRowItem): void {
        if (row.node.group) {
            return;
        }

        this.visitTitle = row.data.visitName;
        this.hasDataRevision = row.data.hasVisitDataRevision;
        this.resultdata = row.data as unknown as StandardTestResultsData;
        this.labtestId = this.resultdata.labTestResults[0].labTestId;
        this.protocol = 'Loading..';
        this.participantNumber = this.resultdata.labTestResults[0].subjectNumber;
        this.investigatorNumber = 'Loading..';
        this.accessionNumber = this.resultdata.labTestResults[0].accessionNumber;
        this.visitDescription = this.resultdata.labTestResults[0].visitDescription;

    }
    public openpopup(labtestId: number) {
        let data: ModalData = {
            title: 'Data Change',
            data: [],
            protocol: this.protocol,
            participantNumber: this.participantNumber,
            investigatorNumber: this.investigatorNumber,
            accessionNumber: this.accessionNumber,
            visitDescription: this.visitDescription,
            closeButtonText: 'Close',
            reverseButtons: true,
            displayClose: false,
            type: 'visit',
            labTestId: labtestId
        };
        this.modalDialogService.showDialog(data).toPromise();
    }
}